import React, { useState, useRef } from 'react';
import Guid from "devextreme/core/guid";
import { Toolbar as RealToolbar } from 'devextreme-react/toolbar';
import ReshapeDataSource from '../datasource/ReshapeDataSource';
import { useAuthStore } from '../hooks/useAuthStore';
import DropDownGridReportViewList from './DropDownGridReportViewList';
import LicenceDataSource from '../datasource/LicenceDataSource';
import RefUtils from '../utils/RefUtils';

export const CustomComponentDefauldId = new Guid("f9d9f528-c93a-4215-b78f-032b6b884f84");
const CustomComponentDefauldName = "---Базовый---";

const DropDownUserReportComponentList = ({ reportId, getCurrentStructure, onSelectedItemChange, defaultValue, onCanSetupState }) => {
    const customcomponentUrl = "/api/main/customcomponent";
    const authStore = useAuthStore();
    const ref = useRef(null);
    const dataSourceLoaded = () => {
        const timeOutMs = 300;
        setTimeout(() => {
            ref?.current?.instance?.option("value", [defaultValue]);
        }, timeOutMs);        
    }
    const [dataSource, setDataSource] = useState(new ReshapeDataSource());
    const [dataPrepared, setDataPrepared] = useState(false);
    const [getTextBoxValue, setTextBoxValueSetFunction] = useState(null);
    const [canSetup, setCanSetup] = useState(false);


    const filt = [
        "ReportId" + " eq " + (reportId ? reportId.toString() : (new Guid()).toString()),
//        "ComponentId" + " eq " + (componentId ? componentId.toString() : (new Guid()).toString()),
    ];


    const licenceStore = LicenceDataSource.licenceStore(
        {
            url: customcomponentUrl,
            authStore: authStore,
            cacheDuration: 0,
            filter: filt,
        }
    );

    const insertCustomComponent = async (data) => {
        try {
            await licenceStore.insert(data);
        }
        catch (e) {
            console.log(e);
        }
    }
    const updateCustomComponent = async (data) => {
        let key = data.Id;
        try {
            await licenceStore.update(key, data)
        }
        catch (e) {
            console.log(e);
        }
    }


    const saveCurrentCustomComponent = async () => {
        if (!getCurrentStructure) return;
        const jsonObject = getCurrentStructure();
        const jsonObjectStr = JSON.stringify(jsonObject);
        const name = (getTextBoxValue && getTextBoxValue()) || "Новый ";
        const itemByName = dataSource.dataSource.items().find(item => item.Name == name);
        const customComponent = {
            Id: itemByName ? itemByName.Id : (new Guid()),
            Name: name,
            JsonObject: jsonObjectStr,
            ReportId: reportId,
//            ComponentId: componentId,
        }
        if (itemByName) {
            await updateCustomComponent(customComponent);
        }
        else {
            await insertCustomComponent(customComponent);
        }
        await fillDataSource();
    }

    const deleteCustomComponent = async (data) => {
        let key = data.Id;
        try {
            await licenceStore.remove(key);
            await fillDataSource();
        }
        catch (e) {
            console.log(e);
        }
    }


    const fillDataSource = async () => {
        let url = customcomponentUrl;
        const res = ((await dataSource.reFillDataAsync(
            {
                url: url,
                authStore: authStore,
                filter: filt,
            }
        )) || [])
            ;
        dataSource.listStore.insert({ Id: CustomComponentDefauldId, Name: CustomComponentDefauldName });
    }

    React.useEffect(() => {
        fillDataSource();
        if (onCanSetupState) {
            onCanSetupState([canSetup, setCanSetup])
        } 
        dataSourceLoaded();
    }, [canSetup, onCanSetupState]);

    const showSetup = () => {
        return (getCurrentStructure && getCurrentStructure()) && localStorage.getItem("showSetupAtMainIsAuthToolbar") == "true" && authStore.user?.IsAdmin;
    }

    const conditionForItemDelete = (data) => {
        let res = canSetup && (data?.Id != CustomComponentDefauldId);
        return res;
    }
    return (
        <div style={{ width: "100%" }}>
            <DropDownGridReportViewList
                key={canSetup ? 1 : 0}
                //defaultValue={defaultValue}
                dataSource={dataSource.dataSource}
                innerRef={ref}
                //                dataSource={licenceStore}
                afterDelete={deleteCustomComponent}
                onSelectedItemChange={onSelectedItemChange}
                fieldIdName="Id"
                fieldTitleName="Name"
                placeholder="Внешний вид таблиц"
                editing={true}
                deleting={canSetup}
                sortByName={true}
                getTextBoxValueSetFunction={setTextBoxValueSetFunction}
                conditionForItemDelete={conditionForItemDelete}
                dataColumns={
                    [
                        {
                            dataField: "Id",
                            visible: false,
                            allowEditing: false,
                        },
                        {
                            dataField: "Name",
                            visible: true,
                            allowEditing: true,
                            sortOrder: "asc",
                            sortIndex: 0,
                        },
                    ]
                }
            />
            <RealToolbar
                className="report-control-band-2"
                items={
                    [
                        {
                            widget: 'dxButton',
                            location: 'before',
                            visible: true,
                            options: {
                                icon: 'save',
                                hint: "Сохранить",
                                onClick: () => saveCurrentCustomComponent(),
                            },
                        }
                    ]                    
                }
                visible={canSetup}
            />
        </div>
    )
}

export default DropDownUserReportComponentList;
